import InformationCircle from '@heroicons/react/24/outline/InformationCircleIcon';
import React from 'react';
import Tooltip from '../Tooltip';

export default function GiftTile({ name, usdValue, selected, onClick, infoText = '' }) {
  let borderColor = 'border-slate-300 hover:border-mint-600 hover:border-2';
  if (selected) {
    borderColor = 'border-2 border-mint-600';
  }
  return (
    <div
      className={`p-8 shadow-md rounded-md bg-white text-center ${borderColor} border-solid border cursor-pointer`}
      onClick={onClick}
    >
      <div className="text-md">
        {name}
        {!!infoText && (
          <Tooltip
            content={
              <div className="bg-black text-white shadow-md shadow-giveGray-600 px-2 py-1 rounded-md max-w-xs">
                {infoText}
              </div>
            }
          >
            <InformationCircle className="h-5 w-5 inline mx-1 -mt-1 text-giveGray-500" />
          </Tooltip>
        )}
      </div>
      <div className="font-bold text-3xl">${usdValue}</div>
    </div>
  );
}
